import root from 'window-or-global';
import {Logger} from '../utils/Logging';

export interface Root {
    __isLauncher: boolean;
    ue?: {__mocked: boolean};
}

export enum BridgeType {
    LAUNCHER = 'LAUNCHER',
    WEB = 'WEB',
    MOCK = 'MOCK'
}

export enum ResponseType {
    Added = 'Added',
    AppStartedRunning = 'AppStartedRunning',
    AppStoppedRunning = 'AppStoppedRunning',
    BeginInstall = 'BeginInstall',
    BeginUninstall = 'BeginUninstall',
    ClearNotification = 'ClearNotification',
    CloudSyncComplete = 'CloudSyncComplete',
    CloudSyncStarted = 'CloudSyncStarted',
    InstallCanceled = 'InstallCanceled',
    InstallComplete = 'InstallComplete',
    InstallPaused = 'InstallPaused',
    InstallQueued = 'InstallQueued',
    LaunchFailed = 'LaunchFailed',
    LaunchSuccess = 'LaunchSuccess',
    Notification = 'Notification',
    PresenceUpdate = 'PresenceUpdate',
    RecentlyPlayedUpdate = 'RecentlyPlayedUpdate',
    RefetchUserBuildsComplete = 'RefetchUserBuildsComplete',
    Removed = 'Removed',
    ServerStatusChange = 'ServerStatusChange',
    UninstallComplete = 'UninstallComplete',
    WaitingRoomBeginWait = 'WaitingRoomBeginWait',
    WaitingRoomWaitComplete = 'WaitingRoomWaitComplete'
}

export const resolveBridgeType = (): BridgeType => {
    const {__isLauncher, ue} = root as Root;
    if (__isLauncher && ue) {
        return ue.__mocked ? BridgeType.MOCK : BridgeType.LAUNCHER;
    }
    return BridgeType.WEB;
};

export const executeBridgeCall = <T>(
    context: any,
    method: string,
    params: any[] = []
): Promise<T> => {
    if (!context || !context[method]) {
        console.error(`Method was not found ${method} on bridge`);
        return Promise.reject(`Method was not found ${method} on bridge`);
    }
    const promise = context[method](...params);
    return promise.then ? promise : Promise.resolve(promise);
};

export const getContext = ueBridgeName => (root.ue && root.ue[ueBridgeName]) || {};

export const createBridgeCaller = (ueBridgeName: string, logger: Logger) => {
    return <T>(method: string, params: any[] = []): Promise<T> => {
        logger.log(method, {params});
        return executeBridgeCall<T>(getContext(ueBridgeName), method, params);
    };
};

export const contextHasBridgeFunction = (ueBridgeName: string, ueFunctionName: string) => {
    const context = getContext(ueBridgeName);
    return !!(context && context[ueFunctionName]);
};
